<template>
  <div id="error-404" class="page-content">
    <div class="container">
      <div class="inner">
        <img src="~assets/images/bg/logo-6.png" class="error-logo" alt="eon logo">
        <div class="error-title">
          <h2>{{ $t('message_server_error_description') }}</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'Error503',
  methods: {
    ...mapMutations([
      'UPDATE_IS_LOADING'
    ])
  },
  created () {
    this.UPDATE_IS_LOADING(false)
  },
  mounted: function () {
    document.body.classList.add('error-page')
  },
  beforeDestroy: function () {
    document.body.classList.remove('error-page')
  }
}
</script>

<style scoped lang="scss">
  .page-content {
    margin-top: 0;
  }
  .container {
    display: flex;
    max-width: 640px;
    align-items: center;
  }
  .inner {
    width: 100%;
    padding-top: 100px;
  }
  .error-logo {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 80px;
  }
  .error-title {
    text-align: center;
    margin-bottom: 45px;
  }
</style>

<style lang="scss">
  body {
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/containers/sections/Error/503/_main.vue